import { useQuery, useMutation, useQueryClient } from 'react-query'

export const useReactQuery = (useReactQueryObject, onSuccess) => {
  const queryId = Array.isArray(useReactQueryObject.payloadDetails.queryId)
    ? ['Reports', ...useReactQueryObject.payloadDetails.queryId]
    : ['Reports', useReactQueryObject.payloadDetails.queryId]
  return useQuery(
    queryId,
    // () => fetchSuperHeros(payloadDetails),
    // () => axios.get(payloadDetails.url),
    () => useReactQueryObject.payloadDetails.urlFunc(useReactQueryObject.payloadDetails.payload),
    {
      cacheTime: 1000 * 60 * 10, // Data will be cached for X time
      staleTime: useReactQueryObject.payloadDetails?.getLatest ? 0 : 1000 * 60 * 10, // This will not even hit the Server to get latest data
      refetchOnMount: false, // This load data once and after that, there wont be any API HIT // default its true
      refetchOnWindowFocus: false, // Don't want to load any data on window focus
      enabled: useReactQueryObject.enabled ?? true, // This will be stopped on component load and will happen onClick of a button
      onSuccess,
      // onSuccess:(s) => {
      //     if(s?.respData?.response?.status === 500){
      //         console.log('e22222 = ', s.respData)
      //         // onError(s.respData.response)
      //         // throw new Error(s.respData.response);
      //     // } else {
      //     //     console.log('s2 = ',s)
      //     //     onSuccess(s)
      //     } else {
      //         return s
      //     }
      // },
      // onError:(e) => {console.log('e = ',e)},
      // throwOnError: true,
      ...useReactQueryObject?.queryDetails,
      // cacheTime: 0,
      // staleTime: 0
    }
  )
}
/*
export const useReactQueryRefetch = (useReactQueryObject) => {
    // const queryId = Array.isArray(useReactQueryObject?.payloadDetails?.queryId) ? ['Reports', ...useReactQueryObject.payloadDetails.queryId] : ['Reports', useReactQueryObject.payloadDetails.queryId]
    const url = useReactQueryObject.payloadDetails.urlFunc(useReactQueryObject.payloadDetails.payload)
    // const queryClient = useQueryClient()

    console.log('url - ', url)

    return useMutation(url)

    // return useMutation(url, {
    //     onSuccess: () => {
    //         queryClient.invalidateQueries(queryId)
    //     }
    // })
}
*/
// https://www.youtube.com/watch?v=2s2iJLLDwgk&list=PLC3y8-rFHvwjTELCrPrcZlo6blLBUspd2&index=14
